import { PaymentDocument } from '../models/settlement-action.model';
import { Settlement } from '../models/settlement.model';

const linkedDteIds = new Set<number>();

// Un DTE cuadra con el total de la liquidación y otro no, para probar el rechazo por monto.
export function mockPaymentDocuments(settlement: Settlement): PaymentDocument[] {
  const total = settlement.totalAmount ?? 0;
  const documents: PaymentDocument[] = [
    {
      dteId: settlement.settlementId * 10 + 1,
      documentNumber: 63690,
      documentDate: '2026-10-09T00:00:00.000Z',
      documentType: 'MIXTO',
      taxableAmount: 9050,
      exemptAmount: Math.max(total - 9050 - 1720, 0),
      taxAmount: 1720,
      taxRate: 19,
      totalAmount: total,
    },
    {
      dteId: settlement.settlementId * 10 + 2,
      documentNumber: 63653,
      documentDate: '2026-10-09T00:00:00.000Z',
      documentType: 'EXENTO',
      taxableAmount: 0,
      exemptAmount: 72403,
      taxAmount: 0,
      taxRate: 0,
      totalAmount: 72403,
    },
  ];
  return documents.filter((document) => !linkedDteIds.has(document.dteId));
}

export const markPaymentDocumentLinked = (dteId: number): void => {
  linkedDteIds.add(dteId);
};
